import Loading from "../../assets/icons/Loading";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { UserAddress, UserOrder } from "../../store/slice/userSlice";
import { AppDispatch, RootState } from "../../store/store";
import { fetchAddresses } from "../Purchase/Purchase.tools";
import "./Invoice.scss";
import { fetchOrder } from "./Invoice.tools";
import OrderSummary from "./components/OrderSummary/OrderSummary";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const Invoice = () => {
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState<UserOrder | undefined>();
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.user);
  const [addresses, setAddresses] = useState<UserAddress[] | undefined>(
    undefined
  );
  const [deliveryAddress, setDeliveryAddress] = useState<
    UserAddress | undefined
  >(undefined);

  useEffect(() => {
    fetchAddresses(setAddresses, setLoading, () =>
      dispatch(refreshAccessToken())
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchOrder(params.orderId!, setOrder, setLoading, () =>
      dispatch(refreshAccessToken())
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (addresses && addresses?.length > 0) {
      setDeliveryAddress(
        addresses.find((address: any) => !!address.isDefaultShipping) ||
          addresses[0]
      );
    }
  }, [addresses]);

  return loading ? (
    <div className="loading">
      <Loading />
    </div>
  ) : (
    <div id="invoice-page">
      <div id="first-line">
        <h1>MERCI POUR VOTRE COMMANDE</h1>
        <p>
          Un e-mail de confirmation vous a été envoyé à l’adresse 
          {user?.email_address}
        </p>
      </div>
      <div id="second-line">
        <div id="delivery">
          <p>
            <b>Adresse de livraison</b>
            <br />
            {deliveryAddress?.fullName}
            <br />
            {deliveryAddress?.addressLine1}
            <br />
            {deliveryAddress?.postalCode} {deliveryAddress?.city}
          </p>
          <p>
            <b>Téléphone de contact</b>
            <br />
            {deliveryAddress?.phone}
          </p>
        </div>
        <div id="invoice">
          <p>
            <b>Numéro de commande :</b>
            <br />
            {order?.orderNumber}
          </p>
          {/* <button onClick={() => alert("Work in progress")}>
            Télécharger la facture
          </button> */}
        </div>
      </div>
      {/* <div id="product-lister"></div> */}
      <OrderSummary items={order?.items} />
      <p>
        <b>
          Pour toute question relative à votre commande, vous pouvez nous
          joindre au <a href="tel:+33169349228">01 69 34 92 28</a>.
        </b>
      </p>
    </div>
  );
};

export default Invoice;
